import { FormlyFieldConfig } from "@ngx-formly/core";
import { testo_privacy } from "./privacy";
import { environment as env } from "environments/environment";

export const PrivacyDelegaStep: FormlyFieldConfig[] =
    [
        {
            "key": "delega",
            type:'mat-radio',
            props: {
                label: `Eventuale delega alla presentazione dell'istanza`,
                color: 'primary',
                required: true,
                options: [
                    { value: 1, label: "Istanza presentata dal titolare" },
                    { value: 2, label: "Istanza presentata da soggetto terzo" }
                ],
            },
            wrappers: ['form-field'],
        },
        {

            props: {
                label: 'Informativa sulla privacy',
                slabel: 'Informativa sulla privacy',
                description: `Leggi l'informativa sulla privacy e clicca sul check di approvazione`
            },
            fieldGroup: [
                {
                    expressions:{
                        template:()=>testo_privacy(env)
                    }
                },
                {
                    key: 'privacy',
                    type: 'mat-checkbox',
                    props: {
                        indeterminate: false,
                        required: true,
                        color: 'primary',
                        label: 'Ho letto le informazioni sul trattamento della privacy',
                    },
                    validators: {
                        validation: ['requiredTrue'],
                    },
                }

            ]
        }
    ]
